import { faFileWord } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import * as Dialog from "@radix-ui/react-dialog";
import { Button } from "../../../../components";
import { dialogsState } from "../../../../state/dialogs";
import { useSnapshot } from "valtio";
import { downloadProfileAsWord } from "../../../../requests";
import { toast } from "sonner";

interface Props {
  open: boolean;
}

export const WordExportInfoDialog = ({ open }: Props) => {
  const { showWordExportInfo } = useSnapshot(dialogsState);

  return (
    <Dialog.Root open={open}>
      <Dialog.Portal>
        <Dialog.Overlay className="fixed inset-0 bg-black bg-opacity-50 z-50" />
        <Dialog.Content className="fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-red-1 rounded-2xl p-10 shadow-lg z-50 max-w-md w-full mx-4">
          <div className="flex flex-col justify-center items-center">
            <FontAwesomeIcon icon={faFileWord} size="4x" />
            <h2 className="text-lg font-extrabold text-black mt-10">
              Word Export
            </h2>

            <Dialog.Description className="text-sm text-gray-6 mt-4 text-center mb-10">
              The Word Export feature is currently limited. It will include the
              <span className="font-bold"> same optimized</span> information as
              the PDF and link versions but have the following limitations:
              <ul className="mt-2">
                <li>- No profile pictures or logos</li>
                <li>- No skill icons</li>
                <li>- No sorted skill stack</li>
              </ul>
            </Dialog.Description>

            <Button
              variant="primary"
              className="mt-4"
              onClick={() => {
                dialogsState.showWordExportInfo = false;

                const toastId = toast.loading(`Downloading Word document...`);
                downloadProfileAsWord(dialogsState.showWordExportInfoProfileId)
                  .then(() => {
                    dialogsState.showWordExportInfoProfileId = "";
                    toast.success(`Word document downloaded successfully!`, {
                      id: toastId,
                    });
                  })
                  .catch(() => console.log("Download failed"));
              }}
            >
              Continue
            </Button>
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
};
